import { useEffect, useState } from 'react';
import { AllowancesAPI } from '../../services/external/APIs';
import { AllowanceModel } from '../../models/allowances/allowanceModel';

/**
 * Hook to fetch allowances/bonuses list
 * @returns AllowanceModel[]
 * @returns AllowanceModel[]
 * @returns boolean
 * @returns (newState: AllowanceModel[]) => void
 */
export const useGetAllowancesList = () => {
    const [allowancesList, setAllowancesList] = useState<AllowanceModel[]>([]);
    const [allowancesListCopy, setAllowancesListCopy] = useState<AllowanceModel[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        AllowancesAPI.getAll()
            .then((res) => {
                setAllowancesListCopy(res);
                setAllowancesList(res);
            })
            .catch((error) => {
                console.error('Error loading allowances:', error);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, []);

    return {
        allowancesList,
        allowancesListCopy,
        isLoadingDataList: isLoadingData,
        setAllowancesListCopy,
        setAllowancesList,
        setIsLoadingData,
    };
};